import styled from "styled-components";
import PeakPercent from "../../atoms/peak/PeakPercent";
import { CLOUDN_COLORS, COLORS } from "../../../constants/colors";
import PeakDetailInfo from "../../atoms/peak/PeakDetailInfo";
import PeakChart from "../../molecules/peak/PeakChart";
import { PeakMartCardProps } from "../../../constants/types";
import {
  getExceptionNaNInfinityForRatio,
  getPeakChartData,
} from "../../../constants/function";

const PeakMartCard = (props: PeakMartCardProps) => {
  return (
    <Container>
      <InfoBox>
        <Title>{props.data.name}</Title>
        <NowPeak>
          {props.data.now.toLocaleString()} <span className="unit">kW</span>
        </NowPeak>
        <PeakPercent
          type="목표"
          percent={getExceptionNaNInfinityForRatio(
            props.data.now,
            props.data.target,
            1
          )}
        />
        <PeakPercent
          type="전주"
          percent={getExceptionNaNInfinityForRatio(
            props.data.now,
            props.data.last,
            1
          )}
        />
        <PeakDetailInfo type="예측" value={props.data.prediction} />
        <PeakDetailInfo type="목표" value={props.data.target} />
        <PeakDetailInfo type="전주" value={props.data.last} />
      </InfoBox>
      <PeakChart
        data={getPeakChartData(props.data.chart)}
        target={props.data.target}
      />
    </Container>
  );
};

export default PeakMartCard;

const Container = styled.div`
  width: 49.5%;
  height: 30%;
  border: 0.15vw solid ${CLOUDN_COLORS.logoSkyBlue};
  box-sizing: border-box;
  margin-bottom: 1%;
  padding: 0.7%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const InfoBox = styled.div`
  width: 33%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const Title = styled.div`
  width: 100%;
  height: 20%;
  font-size: 1.5vw;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.2vw solid ${COLORS.lightGray2};
`;

const NowPeak = styled.div`
  width: 100%;
  height: 30%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  font-size: 2.6vw;
  font-weight: 500;

  .unit {
    font-size: 1.5vw;
    padding: 6% 0 0 5%;
  }

  /* border-bottom: 0.2vw solid ${COLORS.deepGray2}; */
`;
